import * as req from 'api/actions';
import * as c from './constant';

export const getHistoryList = (machineryId, payload, callback) =>
  req.list(
    c.GET_MACHINERY_HISTORY_LIST,
    `api/v1/rpt/administrator/machineries/machinery_applications/${machineryId}/machinery_history_logs`,
    payload,
    callback
  );

export const getSingleHistory = (applicationId, historyId, callback) =>
  req.item(
    c.GET_SINGLE_HISTORY,
    `api/v1/rpt/administrator/machineries/machinery_applications/${applicationId}/machinery_history_logs/${historyId}`,
    callback
  );

export const getMachineryHistoryAppraisalList = (id, payload, callback) =>
  req.list(
    c.GET_MACHINERY_APPRAISAL_HISTORY_LIST,
    `/api/v1/rpt/administrator/machineries/history_logs/${id}/property_appraisal_logs`,
    payload,
    callback
  );

export const getPropertyAssessmentHistoryList = (id, payload, callback) =>
  req.list(
    c.GET_MACHINERY_PROPERTY_ASSESSMENT_HISTORY_LIST,
    `/api/v1/rpt/administrator/machineries/history_logs/${id}/property_assessment_logs`,
    payload,
    callback
  );

export const getRecordofSupAssessmentHistoryList = (id, payload, callback) =>
  req.list(
    c.GET_MACHINERY_RECORD_OF_SUP_ASSESSMENT_HISTORY_LIST,
    `/api/v1/rpt/administrator/machineries/history_logs/${id}/record_of_sup_assessment_logs`,
    payload,
    callback
  );

export const getTransactionHistoryList = (id, payload, callback) =>
  req.list(
    c.GET_MACHINERY_TRANSACTION_HISTORY_LIST,
    `api/v1/rpt/administrator/machineries/history_logs/${id}/transactions_logs`,
    payload,
    callback
  );
